(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('EmailTemplateService', EmailTemplateService);

    function EmailTemplateService(lodash) {
        return {
            getDefaultTinyMCEOptions: getDefaultTinyMCEOptions,
        };

        function getDefaultTinyMCEOptions() {
            return {
                plugins: ['link', 'image', 'autoresize', 'paste', 'noneditable'].join(' '),
                menubar: false,
                toolbar: [
                    ['undo', 'redo'].join(' '),
                    ['bold', 'italic', 'underline'].join(' '),
                    ['bullist', 'numlist'].join(' '),
                    ['outdent', 'indent'].join(' '),
                    ['alignleft', 'aligncenter', 'alignright'].join(' '),
                    ['link'].join(' '),
                ].join(' | '),
                min_height: 300,
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
                paste_preprocess: function (plugin, args) {
                    var html_content = args.content;

                    var unclean_dom = $('<div />').html(html_content);
                    unclean_dom.find('*').removeAttr('class').removeAttr('id');
                    var replace_html_value = unclean_dom.html();

                    args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                }
            };
        }
        // return {
        //     generateOptions: generateOptions,
        //     getDefaultMessageInputOptions: getDefaultMessageInputOptions,
        //     initDefaultModelField: initDefaultModelField
        // };
        //
        // function generateOptions(option) {
        //     return angular.merge(
        //         {},
        //         getDefaultOptions(),
        //         option
        //     );
        // }
        //
        // function getDefaultOptions() {
        //     return {
        //         messageInput: getDefaultMessageInputOptions()
        //     };
        // }
        //
        // function initDefaultModelField(inputoptions) {
        //     delete inputoptions.model.attachments;
        //     if (!lodash.has(inputoptions.model, 'type')) {
        //         lodash.set(inputoptions, 'model.type', inputoptions.options.value);
        //     }
        //     if (lodash.has(inputoptions, 'options.elements')) {
        //         // if (lodash.isEmpty(inputoptions.model)) {
        //         //     lodash.set(inputoptions, 'model.type' ,inputoptions.options.value);
        //         // }
        //
        //         angular.forEach(inputoptions.options.elements, function (val, idx) {
        //             if (lodash.has(inputoptions.model, val.name)) {
        //                 lodash.set(inputoptions.model, val.name, val.value);
        //             }
        //         });
        //     }
        // }
        //
        // function getDefaultMessageInputOptions() {
        //     return {
        //         plugins: ['link', 'image', 'autoresize', 'paste', 'noneditable'].join(' '),
        //         // plugins: 'link image autoresize paste noneditable code',
        //         menubar: false,
        //         toolbar: [
        //             ['undo', 'redo'].join(' '),
        //             ['bold', 'italic', 'underline'].join(' '),
        //             ['bullist', 'numlist'].join(' '),
        //             ['outdent', 'indent'].join(' '),
        //             ['alignleft', 'aligncenter', 'alignright'].join(' '),
        //             ['link'].join(' '),
        //         ].join(' | '),
        //         // toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent | alignleft aligncenter alignright | link',
        //         preview_styles: false,
        //         resize: true,
        //         statusbar: false,
        //         autoresize_bottom_margin: 0,
        //         content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
        //         noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
        //         // paste_as_text: true,
        //         // paste_word_valid_elements: "b,strong,i,em,h1,h2",
        //         paste_preprocess: function (plugin, args) {
        //             var html_content = args.content;
        //
        //             var unclean_dom = $('<div />').html(html_content);
        //             unclean_dom.find('*').removeAttr('class').removeAttr('id');
        //             var replace_html_value = unclean_dom.html();
        //
        //             args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
        //         }
        //     };
        // }
    }
})();